/* Wtul – skrypty motywu (bez zewnętrznych bibliotek) */
(function () {
  'use strict';

  var cfg = window.WtulTheme || {};

  /* ---------- Format ceny zgodny z ustawieniami sklepu ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || cfg.moneyFormat || '{{amount_with_comma_separator}} zł';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(num, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var value = (num / 100).toFixed(precision);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(re);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': out = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = withDelimiters(cents, 2, "'", '.'); break;
      default: out = withDelimiters(cents, 2);
    }
    return format.replace(re, out);
  }
  window.WtulTheme = cfg;
  cfg.formatMoney = formatMoney;

  /* ---------- Pasek ogłoszeń: rotacja ---------- */
  function initAnnouncement() {
    var track = document.querySelector('[data-announcement]');
    if (!track) return;
    var items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Menu mobilne ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var header = document.querySelector('[data-header]');
    if (!drawer || !header) return;
    drawer.addEventListener('toggle', function () {
      var rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--drawer-top', Math.max(rect.bottom, 0) + 'px');
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) drawer.open = false;
    });
  }

  /* ---------- Strona produktu ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var formId = section.getAttribute('data-form-id');
    var form = document.getElementById(formId);

    /* Galeria */
    var track = section.querySelector('[data-gallery-track]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    var counter = section.querySelector('[data-gallery-counter]');
    var slides = track ? track.children : [];

    function currentIndex() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(index, smooth) {
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function syncGallery() {
      var idx = currentIndex();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      var active = thumbs[idx];
      if (active && active.parentElement && active.parentElement.parentElement) {
        var list = active.parentElement.parentElement;
        var left = active.parentElement.offsetLeft - list.clientWidth / 2 + active.clientWidth / 2;
        list.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(syncGallery);
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
      });
      var prev = section.querySelector('[data-gallery-prev]');
      var next = section.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(currentIndex() - 1);
        if (e.key === 'ArrowRight') goTo(currentIndex() + 1);
      });
    }
    function showMedia(mediaId) {
      if (!track || !mediaId) return;
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === String(mediaId)) { goTo(n); return; }
      }
    }

    if (!form || !product) return;

    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var baseLabel = addLabel ? addLabel.getAttribute('data-label') : '';
    var priceWrap = section.querySelector('[data-price-wrap] .price');
    var bundles = section.querySelectorAll('[data-bundles] input[type="radio"]');
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyBtn = section.querySelector('[data-sticky-button]');

    var variant = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    if (variant.featured_media && track) {
      var startId = String(variant.featured_media.id);
      var jump = function () {
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].getAttribute('data-media-id') === startId) {
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = n * track.clientWidth;
            track.style.scrollBehavior = '';
            syncGallery();
            return;
          }
        }
      };
      jump();
      requestAnimationFrame(jump);
      window.addEventListener('load', jump);
      setTimeout(jump, 400);
    }

    function selectedBundle() {
      for (var n = 0; n < bundles.length; n++) if (bundles[n].checked) return bundles[n];
      return null;
    }
    function bundleTotal(input) {
      var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
      var disc = parseInt(input.getAttribute('data-discount'), 10) || 0;
      var full = variant.price * qty;
      var save = Math.floor(full * disc / 100);
      return { qty: qty, disc: disc, full: full, save: save, total: full - save };
    }
    function currentQty() {
      return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    }

    function render() {
      /* cena główna */
      if (priceWrap) {
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceWrap.innerHTML = html;
        priceWrap.classList.toggle('price--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      }
      /* pakiety */
      bundles.forEach(function (input) {
        var t = bundleTotal(input);
        var box = input.nextElementSibling;
        if (!box) return;
        var elTotal = box.querySelector('[data-bundle-total]');
        var elFull = box.querySelector('[data-bundle-full]');
        var elSave = box.querySelector('[data-bundle-save]');
        var elUnit = box.querySelector('[data-bundle-unit]');
        if (elTotal) elTotal.textContent = formatMoney(t.total);
        if (elFull) elFull.textContent = formatMoney(t.full);
        if (elSave) elSave.textContent = 'Oszczędzasz ' + formatMoney(t.save);
        if (elUnit) elUnit.textContent = formatMoney(Math.floor(t.total / t.qty)) + ' / szt.';
      });
      /* ilość i suma */
      var total;
      var sel = selectedBundle();
      if (sel) {
        var bt = bundleTotal(sel);
        if (qtyInput) qtyInput.value = bt.qty;
        total = bt.total;
      } else {
        total = variant.price * currentQty();
      }
      var available = !!variant.available;
      if (addBtn) addBtn.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (baseLabel + ' · ' + formatMoney(total)) : 'Wyprzedane';
      if (stickyPrice) stickyPrice.textContent = formatMoney(total);
    }

    /* warianty */
    var optionInputs = section.querySelectorAll('[data-option-index]');
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        optionInputs.forEach(function (i) {
          if (i.checked) selected[parseInt(i.getAttribute('data-option-index'), 10)] = i.value;
        });
        var match = product.variants.filter(function (v) {
          return v.options.every(function (opt, n) { return selected[n] === undefined || opt === selected[n]; });
        })[0];
        var label = section.querySelector('[data-option-label="' + input.getAttribute('data-option-index') + '"]');
        if (label) label.textContent = input.value;
        if (!match) {
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          var near = product.variants.filter(function (v) { return v.options[idx] === input.value && v.featured_media; })[0];
          if (near) showMedia(near.featured_media.id);
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Niedostępne';
          return;
        }
        variant = match;
        idInput.value = variant.id;
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        render();
      });
    });

    /* pakiety */
    if (bundles.length && !selectedBundle()) bundles[0].checked = true;
    bundles.forEach(function (input) { input.addEventListener('change', render); });

    /* licznik ilości (gdy pakiety wyłączone) */
    section.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.max(1, currentQty() + step);
        render();
      });
    });
    if (qtyInput && !bundles.length) qtyInput.addEventListener('input', render);

    /* blokada podwójnego kliknięcia */
    form.addEventListener('submit', function () {
      if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); }
    });

    /* przyklejony pasek */
    var mainAtc = section.querySelector('[data-main-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      });
      io.observe(mainAtc);
    }

    render();
  }

  /* ---------- Koszyk: +/- ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var timer;
    function submitSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var update = document.createElement('input');
        update.type = 'hidden'; update.name = 'update'; update.value = '1';
        form.appendChild(update);
        form.submit();
      }, 450);
    }
    form.querySelectorAll('[data-cart-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-cart-qty]');
        var v = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-cart-step'), 10);
        input.value = Math.max(0, v);
        submitSoon();
      });
    });
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', submitSoon);
    });
  }

  /* ---------- Logowanie: pokaż reset hasła ---------- */
  function initRecover() {
    var link = document.querySelector('[data-toggle-recover]');
    if (!link) return;
    link.addEventListener('click', function () {
      var el = document.getElementById('RecoverEmail');
      if (el) setTimeout(function () { el.focus(); }, 300);
    });
  }

  function initAll() {
    initAnnouncement();
    initDrawer();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCart();
    initRecover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* edytor motywu: ponowna inicjalizacja po zmianie sekcji */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
  });
})();
